import React from 'react';
import MentorPal from '../Mentorpal/MentorPal';

export const Mentors = () => {
  return (
    <div>
      <MentorPal showExtras={false}  isMentorsPage={true}/>
    </div>
  );
}
